import {
  PluginDealIndividualsForm,
  PluginDealIndividualsFormResponse,
} from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const DEAL_INDIVIDUALS_FORM_PLUGIN_KEY = 'deal-individuals-form';

export const runDealIndividualsForm = (
  constructPost: ConstructPost,
  data: PluginDealIndividualsForm,
): Promise<
  NonPaginatedResponse<PluginDealIndividualsFormResponse> | undefined
> =>
  constructPost<NonPaginatedResponse<PluginDealIndividualsFormResponse>>(
    `${PLUGIN_BASE_PATH}/${DEAL_INDIVIDUALS_FORM_PLUGIN_KEY}`,
    { data },
  );
